import getActionsByDocument from '../../../../components/logs/actions';

const DOCUMENT = 'ORG_CANCELLATION_POLICY_LOGS_';

export default getActionsByDocument(DOCUMENT);
